
























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Tab, Tabs, ActionSheet, Search, RadioGroup, Radio, Cell, CellGroup, Field, Loading, CountDown, Dialog } from "vant";
import trafficPolicyService from "@/service/trafficPolicyService";
declare let AMap: any;
import * as _ from "lodash";
import trafficService from "@/service/trafficService";
import dataShare from "../dataShare";

@Component({
  name: "orderProce",
  components: {
    [Tabs.name]: Tabs,
    [ActionSheet.name]: ActionSheet,
    [Search.name]: Search,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tab.name]: Tab,
    [Field.name]: Field,
    [Loading.name]: Loading,
    [Dialog.Component.name]: Dialog.Component,
  },
})
export default class orderProce extends Vue {
  show = true;
  radio = "";
  waitStatus = "等待应答中";
  reasons = [
    { label: "平台相关", reasons: ["平台派单太远", "上车位置错误/找不到上车位置"] },
    { label: "司机相关", reasons: ["联系不上司机", "司机以各种理由不来接我", "司机要求取消订单", "司机原地不动或反向行驶", "司机要求加价或现金交易", "司机迟到", "不是订单显示车辆或司机"] },
    { label: "自己原因", reasons: ["行程有变，暂时不需要用车", "其他原因"] },
  ];
  get departAddress() {
    return dataShare.trafficDatas.departAddress;
  }
  get arriveAddress() {
    return dataShare.trafficDatas.arriveAddress;
  }
  mounted() {
    this.CreateOrder();
  }

  waitingTime = "00:00";
  recordNum = 0;
  timer: any = "";
  handle() {
    let __self = this;
    __self.recordNum++;
    let m = Math.floor(__self.recordNum / 60);
    let s = __self.recordNum > 59 ? Math.floor(__self.recordNum % 60) : __self.recordNum;
    __self.waitingTime = (m < 10 ? "0" + (m <= 0 ? 0 : m) : m) + ":" + (s < 10 ? "0" + (s < 0 ? 0 : s) : s);
    // 等待时长5分钟 超时处理
    if (m > 4) {
      __self.radio = "平台派单太远";
      __self.waitStatus = "已取消";
      __self.cancelTime = (this as any).$moment().format("YYYY-MM-DD HH:mm");
      __self.$toast.fail("附近车辆较少,暂无司机接单");
      window.clearInterval(this.timer);
    }
  }

  CreateOrder() {
    let __self = this;
    let data = __self.$route.query;
    trafficService.CreateOrder(data).then((res: any) => {
      if (!res.isSucc) {
        __self.$toast(res.message);
        __self.radio = "重复下单";
        __self.waitStatus = "已取消";
        __self.cancelTime = (this as any).$moment().format("YYYY-MM-DD HH:mm");
        window.clearInterval(this.timer);
        return;
      }
      //创建成功后等待司机接单
      //未接单时等待计时
      this.timer = window.setInterval(this.handle, 1000);
      //成功接单后直接跳详情
      __self.gotoDetails(res.result.split("-")[0]);
    });
  }
  // 跳详情
  gotoDetails(orderId?: string) {
    this.$emit("destroyMap");
    this.$router.push({
      path: "/order/details",
      query: {
        OrderID: orderId,
        ServeType: "1555",
        departAddress: JSON.stringify(this.departAddress),
        isTravelStatus: "true",
      },
    });
  }

  isShowDialog = false;
  orderCancel() {
    this.isShowDialog = true;
  }

  isShowCancelReason = false;
  cancel() {
    this.isShowDialog = false;
    this.isShowCancelReason = true;
  }

  back() {
    this.isShowCancelReason = false;
  }
  toBack(){
    history.go(-2)
  }

  cancelTime = "";
  submit() {
    if (!this.radio) {
      this.$toast("请选择取消原因!");
      return;
    }
    this.waitStatus = "已取消";
    this.cancelTime = (this as any).$moment().format("YYYY-MM-DD HH:mm");
    window.clearInterval(this.timer);
    this.isShowCancelReason = false;
  }

  call() {
    window.location.href = "tel://400-088-8020";
  }
}
